<template>
  <div class="info">
    <el-form :inline="true" :model="form" class="demo-form-inline" size="mini">
      <el-form-item label="省份:">
        <el-select
          v-model="form.province"
          placeholder="请选择"
          @change="provinceChangeHandler"
          class="china-select"
        >
          <el-option
            v-for="item in provinceOptionsCopy"
            :key="item.cityid"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="城市:">
        <el-select
          v-model="form.cityId"
          placeholder="请选择"
          @focus="cityFocus"
          @change="cityChangeHandler"
          class="china-select"
        >
          <el-option
            v-for="item in cityOptionsCopy"
            :key="item.cityid"
            :label="item.name"
            :value="item.cityid"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <h2 class="list-name">{{ listname }}</h2>

    <div class="info-list">
      <div class="info-item" v-for="item in data.centers" :key="item.centerid">
        <h4>{{ item.centername }}</h4>
        <p>地址：{{ item.centeradress || "-" }}</p>
        <p>
          自建平台：
          <a class="platform" :href="item.centerlink" target="_blank">
            {{ item.platform || "-" }}
          </a>
        </p>
        <p>
          <el-link
            v-if="item.serviceguide"
            :href="item.serviceguide"
            target="_blank"
            :underline="false"
            >查看办事指南</el-link
          >
        </p>
        <p>
          <el-link
            v-if="item.bidnotice"
            :href="item.bidnotice"
            target="_blank"
            :underline="false"
            >查看招标公告</el-link
          >
        </p>
      </div>
    </div>

    <!-- <el-button class="recommend-btn" type="primary" plain @click="recommendClickHandler"
            v-czc="['交易中心','点击按钮', '惠采购' , 0 ,`tradeCenter-btn-hcg`]">
            推荐平台：惠采购
        </el-button> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      provinceList: [],
      cityList: [],
      provinceOptionsCopy: [], //省份数组
      cityOptionsCopy: [], //城市数组
      form: {
        province: "河北省", //省份
        city: "石家庄市", //城市
        proviceId: "130000",
        cityId: "130100",
      },
    };
  },
  computed: {
    ...mapState({
      search: (state) => {
        return state.dealcenter.search;
      },
      data: (state) => {
        return state.dealcenter.data;
      },
    }),
    listname() {
      // 列表名称
      if (this.search.province && !this.search.city) {
        return `${this.search.province}级平台`;
      } else if (this.search.province && this.search.city) {
        return `${this.search.city}级平台`;
      }
    },
    activeName() {
      return this.$route.query.activeName || "calculter";
    },
  },
  watch: {
    activeName: {
      handler(e) {
        if (e) {
          this.form = {
            province: "河北省", //省份
            city: "石家庄市", //城市
            proviceId: "130000",
            cityId: "130100",
          };
          this.$store.commit("dealcenter/updateCity", this.form.city);
          this.$store.commit("dealcenter/updateProvince", this.form.province);
          this.$store.commit("dealcenter/updateData", {
            // 搜索条件
            province: "河北省", //省份
            city: "石家庄市", //城市
            centername: "", //搜索内容
            activeName: e,
          });
          this.getData();
          this.queryData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 省份选择框改变
     */
    provinceChangeHandler() {
      const that = this;
      if (that.form.province) {
        that.$store.commit("dealcenter/updateProvince", that.form.province);
        let id = that.provinceList.filter(function (val) {
          return val.name == that.form.province;
        })[0].cityid;

        this.cityOptionsCopy = this.cityList.filter(function (val) {
          return val.parentid == id;
        });
        if (that.cityOptionsCopy.length > 0) {
          that.form.city = that.cityOptionsCopy[0].name;
          that.form.cityId = that.cityOptionsCopy[0].cityid;
          that.$store.commit("dealcenter/updateCity", that.form.city);
        } else {
          that.form.city = "";
        }
        that.queryData();
      } else {
        that.form.city = "";
        that.cityOptionsCopy = [];

        that.$store.commit("dealcenter/updateCity", that.form.city);
        that.$store.commit("dealcenter/updateProvince", that.form.province);
      }
    },
    /**
     * 城市选择框改变
     */
    cityChangeHandler() {
      const that = this;
      if (that.form.cityId) {
        let item = that.cityList.filter(function (val) {
          return val.cityid == that.form.cityId;
        })[0]; //.parentid;
        var id = item.parentid;
        var city = item.name;
        that.form.city = city;
        this.form.province = this.provinceList.filter(function (val) {
          if (id) {
            return val.cityid == id;
          }
        })[0].name;

        that.$store.commit("dealcenter/updateCity", that.form.city);
        that.$store.commit("dealcenter/updateProvince", that.form.province);
      } else {
        that.$store.commit("dealcenter/updateCity", that.form.city);
      }
      that.queryData();
    },
    /**
     * 城市选择框获取焦点
     */
    cityFocus() {
      const that = this;
      if (that.form.province) {
        let id = that.provinceList.filter(function (val) {
          return val.name == that.form.province;
        })[0].cityid;
        this.cityOptionsCopy = this.cityList.filter(function (val) {
          return val.parentid == id;
        });
      }
    },
    /**
     * 推荐平台 点击
     */
    recommendClickHandler() {
      // Todo 更换网址
      window.open(`http://www.hbidding.com/`);
    },
    /**
     * 请求数据
     */
    queryData() {
      const that = this;
      that.$get(
        `${this.$store.state.api.webUrl}/navigation/getSearchData.json`,
        that.search,
        (data) => {
          if (data) {
            that.$store.commit(
              "dealcenter/updateactiveName",
              this.$route.query.activeName || "calculter"
            );
            that.$store.commit("dealcenter/updateData", data);
            // 跳转交易中心
            this.$router.push({
              path: "/deal-nav/"+this.activeName,
              query: {
                value: that.search.value,
                province: that.search.province,
                city: that.search.city,
                activeName: this.$route.query.activeName || "calculter",
              },
            });
          }
        }
      );
    },
    getData() {
      const that = this;
      that.$get(`${this.$store.state.api.webUrl}/navigation/getProvince.json`, (data) => {
        if (data) {
          this.provinceList = data;
          this.provinceOptionsCopy = data;
        }
      });
      that.$get(`${this.$store.state.api.webUrl}/navigation/getCityList.json`, (data) => {
        if (data) {
          this.cityList = data;
          this.cityOptionsCopy = data;
        }
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "@css/var.scss";

.info {
  // overflow: scroll;
  height: 100%;
  width: 100%;
  h3 {
    font-size: 15px;
    margin: 10px;
    margin-left: 0;
  }
  .list-name {
    font-size: 18px;
    color: #4381fe;
    margin-bottom: 26px;
  }
  .info-list {
    width: 100%;
    height: 360px;
    overflow: scroll;

    .info-item {
      height: 160px;

      & + .info-item {
        margin-top: 30px;
      }

      h4 {
        font-size: 16px;
        margin-bottom: 18px;
        font-weight: normal;
        color: #333;
        line-height: 1em;
      }
      p {
        font-size: 14px;
        color: #666666;
        line-height: 30px;
      }

      .platform {
        color: #666666;

        &:hover {
          color: $primaryColor;
        }
      }
    }
  }
  .recommend-btn {
    width: 100%;
    margin-top: 20px;
  }
}
.china-select {
  width: 100px;
}
</style>
